module.exports = "\r\n\r\n<ng-http-loader\r\n spinner=\"sk-spinner-pulse\">\r\n</ng-http-loader>\r\n<router-outlet></router-outlet>\r\n"